// extracted by mini-css-extract-plugin
export default {"shipping":"_h-z","header":"ai-z","adjustMarginAndPaddingNewDesign":"bi-z"};